import {injectable} from 'inversify'

import type {IClientIpResolver} from '@/src/ports/services/request-context'

@injectable()
export class ClientIpResolver implements IClientIpResolver {
  async resolve(): Promise<string> {
    return 'unknown'
  }
}